import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../components/Title";
import { CreateTwoTone, DeleteOutlineRounded, Settings } from "@material-ui/icons";
import UserService from "../../services/UserService";
import { DataGrid } from '@material-ui/data-grid';
import Message from "../tools/Message";
import ConfirmationDialog from "../tools/ConfirmationDialog";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { useNavigate, useLocation } from 'react-router-dom';
import { hasPrivilege } from "../../utils/privilege";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import SpecialSettingDialog from "./SpecialSettingDialog";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { TextField, MenuItem, Select, InputLabel, FormControl, Grid} from '@mui/material';
import { LoadingButton } from '@mui/lab';
const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function UserTable(props) {

  const navigate = useNavigate();
  const location = useLocation();
  const iddir=props.dir;
  const idservice=props.idservice;
  const type=props.type;

  const [rows, setRows] = useState([]);
  const [userInfo, setUserInfo] = useState("");
  const classes = useStyles();
  const [isid, setIsid] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'voulez vous supprimer?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    openMessage: false,
    color: 'green',
    messageInfo: '',
  });
  const { openMessage, color, messageInfo } = message;
  const contextData = useContext(userDetailContext);
  const [openSpecialSettingDialog, setOpenSpecialSettingDialog] = React.useState(false);
  const [dialoguesdesactivation,setDialoguesdesactivation]=useState(false);
  const [isLoading,setIsLoading]=useState(false);
  const [idValidatorNumber, setIdValidatorNumber] = useState(0);
  const [validatorNumber, setValidatorNumber] = useState("");
  const [validatorNumberMission, setValidatorNumberMission] = useState("");
  const [id, setId] = useState("");
  const [isValidatorNumberConfigurated, setIsValidatorNumberConfigurated] = useState(false);
  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);


    const [formData, setFormData] = useState({
      endDate: '',
      deactivationType: ''
    }); 

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //       ...formData,
    //       [name]: value,
    //     });
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Si on change de type de désactivation
        if (name === 'deactivationType') {
          // Si l'utilisateur sélectionne "Autre" dans la liste
          if (value === 'autre') {
            setFormData({
              ...formData,
              [name]: 'autre',
              deactivationTypeCustom: '' 
            });
          } else {
            setFormData({
              ...formData,
              [name]: value,
              deactivationTypeCustom: '' 
            });
          }
        } 
        // Pour le champ texte "Autre"
        else if (name === 'deactivationTypeCustom') {
          setFormData({
            ...formData,
            [name]: value,
            // NE PAS modifier deactivationType ici
          });
        }
        // Pour tous les autres champs
        else {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      };

    useEffect(() => {
      loadAllUser();
    }, [location,iddir,idservice,type]);

  const handleDelete = (id) => (ev) => {
    setIsid(id);
    //setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: 'voulez vous supprimer?' });
    setDialoguesdesactivation(true);
  };

   const handleClose = () => {
    setDialoguesdesactivation(false);
   };

  function loadAllUser() {
    setOpenLoadingSimpleBackdrop(true);
    UserService.getAllUserlist(iddir,idservice,type).then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setRows([]);
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
  }
  function confirmDialog() {
   // setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
   setIsLoading(true);
   UserService.updateisactive(isid,formData.endDate,formData.deactivationType,formData.deactivationTypeCustom).then((result) => {
      if (result.status) {
         setIsLoading(false)
         setDialoguesdesactivation(false);
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        loadAllUser();
        setFormData({
          endDate: '',
          deactivationType: '',
          deactivationTypeCustom:''
        })
      } else {
         setDialoguesdesactivation(false);
         setIsLoading(false)
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
    }).catch((err) => {
       setDialoguesdesactivation(false);
       setIsLoading(false)
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
    });
  }
  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }
  function handleCloseMessage() {
    setMessage({ ...message, openMessage: false });
  }


  const handleEdit = (id) => (ev) => {
    navigate("/users/add/" + id);
    window.location.reload();
  };


  function handleCloseSettingDialog() {
    setOpenSpecialSettingDialog(false);
  }

  function handleValidate() {
    // console.log(idValidatorNumber);
    UserService.saveValidatorNumber(userInfo.user_id, validatorNumber, idValidatorNumber).then((result) => {
      if (result && result.status) {
        setIsValidatorNumberConfigurated(true);
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        setOpenSpecialSettingDialog(false);
        loadAllUser();
      }
    });
  }

  function handleChangeNumberOfValidator(ev) {
    const { name, value } = ev.target;
    const newValue = value.replace(/[^0-9]/g, '');
    setValidatorNumber(newValue);
  }


  function handleChangeNumberOfValidatorMission(ev) {
    const { name, value } = ev.target;
    const newValue = value.replace(/[^0-9]/g, '');
    setValidatorNumberMission(newValue);
  }

  const handleClickSpecialSetting = (id) => (ev) => {
    setOpenSpecialSettingDialog(true);
    UserService.checkValidatornumberByUserId(id).then((result) => {
      if (result && result.status) {
        setId(id);
        setIdValidatorNumber(result.data.user_validator_number_id);
        setValidatorNumber(result.data.user_validator_number_validatorNumber);
      } else {
        setValidatorNumber(0);
        setId(id);
      }
    });

    UserService.checkValidatornumberByUserIdMission(id).then((res) => {
      if (res && res.status) {
        setValidatorNumberMission(res.data.user_validator_number_validatorNumber);
      } else {
        setValidatorNumberMission(0);
      }
    });

    UserService.getUserSummaryByUserId(id).then((result) => {
      if (result && result.status) {
        setUserInfo(result.data)
      }
    });
  };

  const columns = [
    {
      field: 'registration_number',
      headerName: 'Matricule',
      width: 150,
    },
    {
      field: 'direction',
      headerName: 'Direction',
      width: 150,
    },
    {
      field: 'service',
      headerName: 'Service',
      width: 150,
    },
    {
      field: 'function_name',
      headerName: 'Fonction',
      width: 150,
    },
    {
      field: 'last_name',
      headerName: 'Nom',
      width: 250,
    },
    {
      field: 'first_name',
      headerName: 'Prénom',
      width: 250,
    },
    {
      field: 'sex_id',
      headerName: 'Sexe',
      width: 150,
      valueGetter: (params) => {
        if (params.row.sex_id === "1") return "Homme";
        if (params.row.sex_id === "2") return "Femme";
        return "";
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
    },
    {
      field: 'telephone',
      headerName: 'Téléphone',
      width: 200,
    },
    {
      field: 'group',
      headerName: 'Groupes',
      width: 250,
    },
    {
      field: 'funding',
      headerName: 'Financement',
      width: 200,
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Button onClick={handleEdit(params.id)} title="Modifier un utilisateur"><CreateTwoTone style={{ color: "black" }} />
            </Button>
            <Button onClick={handleDelete(params.id)} title="Desactiver un utilisateur">
              <DeleteOutlineRounded style={{ color: "red" }} />
            </Button>

            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <Button onClick={handleClickSpecialSetting(params.id)} title="Paramètre spécial">
                <Settings style={{ color: "grey" }} />
              </Button>
            )}
          </div>
        );
      },
      width: 200,
    },
  ];
  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <SpecialSettingDialog openSpecialDialog={openSpecialSettingDialog} handleCloseDialog={handleCloseSettingDialog}
        userInfo={userInfo} handleValidate={handleValidate} validatorNumber={validatorNumber}
        validatorNumberMission={validatorNumberMission} id={id}
        handleChangeNumberOfValidator={handleChangeNumberOfValidator}
        handleChangeNumberOfValidatorMission={handleChangeNumberOfValidatorMission}
      />
      <Title>Listes des Utilisateurs</Title>
      <div style={{ height: "70vh", width: '100%' }} className={classes.root} >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 100, 150, 200]}
          disableSelectionOnClick
        />
      </div>
      <div>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={dialoguesdesactivation}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Confirmation de la désactivation
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Typography gutterBottom>
                Êtes-vous sûr de vouloir désactiver?
               <p> Si oui, veuillez entrer la raison de cette désactivation ainsi que la date de fin de contrat.</p> 
              </Typography>
                <Grid container spacing={2}>
                  {/* Date de fin du contrat */}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label="Date de fin du contrat"
                      type="date"
                      fullWidth
                      variant="outlined"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  </Grid>

                  {/* Type de désactivation */}
                  <Grid item xs={12} sm={12}>
                     <FormControl fullWidth variant="outlined" required>
                        <InputLabel>Type de désactivation</InputLabel>
                        <Select
                          label="Type de désactivation"
                          name="deactivationType"
                          value={formData.deactivationType === 'autre' ? 'autre' : formData.deactivationType}
                          onChange={handleChange}
                        >
                          <MenuItem value="">
                            <em>Veuillez sélectionner un type</em>
                          </MenuItem>
                          <MenuItem value="demission">Démission</MenuItem>
                          <MenuItem value="finContrat">Fin de contrat</MenuItem>
                          <MenuItem value="resiliationContrat">Résiliation du contrat</MenuItem>
                          <MenuItem value="suspensionContrat">Suspension du contrat</MenuItem>
                          <MenuItem value="autre">Autre (précisez)</MenuItem>
                        </Select>
                      </FormControl>

                      {formData.deactivationType === 'autre' && (
                        <TextField
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          label="Précisez le type de désactivation"
                          name="deactivationTypeCustom"
                          value={formData.deactivationTypeCustom || ''}
                          onChange={handleChange}
                          required
                        />
                      )}
                  </Grid>
                  </Grid>
            </DialogContent>
            <DialogActions>
               <Button variant="contained" color="secondary" autoFocus onClick={handleClose}>
                 Annuler
              </Button>
             <LoadingButton
                  variant="contained"
                  color="primary"
                  autoFocus
                  onClick={confirmDialog}
                  loading={isLoading} 
                >
                  Confirmer
                </LoadingButton>
            </DialogActions>
          </BootstrapDialog>
      </div>
    </React.Fragment>
  );
}
